var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar',{on:{"open-login":_vm.handleLoginActive}}),_vm._v(" "),_c('login-modal'),_vm._v(" "),_c('progress',{staticClass:"progress is-large is-primary",attrs:{"max":"6"},domProps:{"value":_vm.stepNr}}),_vm._v(" "),_c('section',{staticClass:"main-content"},[_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }